import { Injectable } from '@angular/core';
import { SagaDate, SagaDatePipe } from '@app/pipes/saga-date/saga-date.pipe';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { MomentService } from '@techwan/ionic-core';

interface CardReceivedTime {
  ObjId: string;
  ReceivedTime: string;
}

const STORAGE_KEY: string = 'MyCardReceivedTime';

@Injectable()
export class MyCardReceivedTimeService {
  constructor(private moment: MomentService, private sagaDate: SagaDatePipe) {}

  setReceivedTime(callcard: CallCard, receivedTime: Date | string | number = Date.now()) {
    const cardReceivedTime: CardReceivedTime = {
      ObjId: callcard.ObjGuid,
      ReceivedTime: this.moment.formatDate(receivedTime, 'YYYY-MM-DDTHH:mm:ss.SSSZ')
    };

    localStorage.setItem(STORAGE_KEY, JSON.stringify(cardReceivedTime));
  }

  getReceivedTime(callcard: CallCard): string {
    const storageItem: string = localStorage.getItem(STORAGE_KEY);
    if (!storageItem) {
      this.setReceivedTime(callcard);
    }
    const cardReceivedTime: CardReceivedTime = JSON.parse(localStorage.getItem(STORAGE_KEY));
    return this.sagaDate.transform(cardReceivedTime.ReceivedTime, SagaDate.SUBMITTED);
  }
}
